const authenticatedRoutes: string[] = [
  '/en-us/business/payment-solutions/supplier-dashboard/view-payment',
  '/en-us/business/payment-solutions/supplier-dashboard/home',
  '/en-us/business/payment-solutions/supplier-dashboard/user-management',
  '/en-us/business/payment-solutions/supplier-dashboard/help',
  '/en-us/business/payment-solutions/supplier-dashboard/account-settings',
  '/en-us/business/payment-solutions/supplier-dashboard/invoices',
  '/en-us/business/payment-solutions/supplier-dashboard/payments',
  '/en-us/business/payment-solutions/supplier-dashboard/orders',
  '/en-us/business/payment-solutions/supplier-dashboard/goods-receipts',
  '/en-us/business/payment-solutions/supplier-dashboard/customers',
  '/en-us/business/payment-solutions/supplier-dashboard/reporting',
  '/en-us/business/payment-solutions/supplier-dashboard/link-account',
  '/en-us/business/one-ap-invoice-management-account/link-account',
];

export const isAuthenticatedRoute = (currentRoute: string): boolean => {
  const matches = authenticatedRoutes.map((authRoute) => {
    if (currentRoute.startsWith(authRoute)) {
      return true;
    }
    return false;
  });
  return matches.includes(true);
};
